import { render, staticRenderFns } from "./PreviewExamItem.vue?vue&type=template&id=132f8964&"
import script from "./PreviewExamItem.vue?vue&type=script&lang=js&"
export * from "./PreviewExamItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports